var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncrement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7.5,
    stroke: "#9CE3C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.5C19.0858 10.5 18.75 10.8358 18.75 11.25C18.75 11.6642 19.0858 12 19.5 12H20.6893L17.1857 15.5037C16.5999 16.0895 15.6501 16.0895 15.0643 15.5037L14.4963 14.9357C13.3247 13.7641 11.4253 13.7641 10.2537 14.9357L6.96967 18.2197C6.67678 18.5126 6.67678 18.9874 6.96967 19.2803C7.26256 19.5732 7.73744 19.5732 8.03033 19.2803L11.3143 15.9963C11.9001 15.4105 12.8499 15.4105 13.4357 15.9963L14.0037 16.5643C15.1753 17.7359 17.0747 17.7359 18.2463 16.5643L21.75 13.0607V14.25C21.75 14.6642 22.0858 15 22.5 15C22.9142 15 23.25 14.6642 23.25 14.25V11.25C23.25 10.8358 22.9142 10.5 22.5 10.5H19.5Z",
    fill: "#0DBA78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrement);
export default __webpack_public_path__ + "static/media/increment.9c0a33ca6571d1b27c2b98b0aa8386e3.svg";
export { ForwardRef as ReactComponent };